import axios from 'axios';

// In dev, VITE_API_URL is empty → relative URLs → Vite proxy handles routing to localhost:8001
// In production, VITE_API_URL is set to the production API base (e.g. https://api.wedsy.co)
export const API_URL = import.meta.env.VITE_API_URL || '';

export const apiClient = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
  withCredentials: true,
});

// Response interceptor for error handling
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle authentication errors — only redirect if user had an active session
    if (error.response?.status === 401) {
      const hadToken = !!localStorage.getItem('token');
      localStorage.removeItem('token');
      if (hadToken) {
        window.location.href = '/login';
      }
      return Promise.reject(error);
    }

    if (error.response?.status === 403 &&
        error.response?.data?.error?.code === 'account_suspended') {
      if (window.location.pathname !== '/trial-expired') {
        window.location.href = '/trial-expired';
      }
      return Promise.reject(error);
    }

    // Don't log validation errors (422) to console - they're expected
    if (error.response?.status === 422) {
      return Promise.reject(error);
    }

    // Only log errors in development
    if (import.meta.env.DEV) {
      if (error.response) {
        console.error('API Error:', error.response.status, error.response.data);
      } else if (error.request) {
        console.error('Network Error:', error.message);
      } else {
        console.error('Request Error:', error.message);
      }
    }

    return Promise.reject(error);
  }
);
